/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Name/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromValidate from 'Data/validate.js'
import React from 'react'
import TysiaInput from 'DesignSystem/TysiaInput/index'
import TysiaInputContent from 'DesignSystem/TysiaInput/TysiaInputContent/index'
import TysiaInputField from 'DesignSystem/TysiaInput/TysiaInputField/index'
import TysiaInputLabel from 'DesignSystem/TysiaInput/TysiaInputLabel/index'



/** @type {import('Simple/types.js').View} */
export default function Name({
  children,
  viewPath = "/DesignSystem/DataVaxiomEmployeeProfessionalsRelationshipsItem/Edit/Content/Details/Office/Name",
  isInvalid,
  onChange
  
}) {
let editProfessionalEmployeeProviderEmployeeResourceEmploymentContractOrganizationNameValueData = fromData.useDataValue({ viewPath,
context: 'edit_professional',
path: 'employee.provider.employee_resource.employment_contract.organization.name',
})
let editProfessionalEmployeeProviderEmployeeResourceEmploymentContractOrganizationNameIsValidData = fromData.useDataIsValid({ viewPath,
context: 'edit_professional',
path: 'employee.provider.employee_resource.employment_contract.organization.name',
validate: fromValidate.textInput,
required: true,
})
let editProfessionalEmployeeProviderEmployeeResourceEmploymentContractOrganizationNameChangeData = fromData.useDataChange({ viewPath,
context: 'edit_professional',
path: 'employee.provider.employee_resource.employment_contract.organization.name',
})
  return (<React.Fragment
>
<TysiaInput
  viewPath={`${viewPath}/TysiaInput`}
 data="edit_professional.employee.provider.employee_resource.employment_contract.organization.name"
 disabled={true}
 validate="/Data/validate.js textInput"
 required={true}
 invalid={!editProfessionalEmployeeProviderEmployeeResourceEmploymentContractOrganizationNameIsValidData}
 value={editProfessionalEmployeeProviderEmployeeResourceEmploymentContractOrganizationNameValueData}
 onChange={editProfessionalEmployeeProviderEmployeeResourceEmploymentContractOrganizationNameChangeData}
>
{childProps => (
<React.Fragment>
<TysiaInputLabel
{...childProps}
  viewPath={`${viewPath}/TysiaInputLabel`}
 text="Office Name"
/>
<TysiaInputContent
{...childProps}
  viewPath={`${viewPath}/TysiaInputContent`}
>
{childProps => (
<TysiaInputField
{...childProps}
  viewPath={`${viewPath}/TysiaInputField`}
 type="text"
/>
)}
</TysiaInputContent>
</React.Fragment>
)}
</TysiaInput>
{children}
</React.Fragment>)
}